module.exports = function(val) {
  return val && typeof val.isValid=='function' && val.isValid();
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/helpers/is-valid-moment-object.js